import Selector from "components/common/Selector";
import { Col } from "antd";
import { useItemVariants } from "graphql/useItemExtras";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import s from "./styles";

function InventoryBody({
  handleChange,
  values,
  setFieldValue,
  setShowAdvancedInventory,
  showAdvancedInventory,
  stockMasters,
}) {
  const { t } = useTranslation();
  const { itemVariants } = useItemVariants();

  const optionsControlStock = [
    { name: t("Items.inventory.noUse"), value: "none" },
    { name: t("Items.inventory.basic"), value: "basic" },
    { name: t("Items.inventory.advanced"), value: "variant" },
  ];

  const handleStockMode = (value) => {
    setFieldValue("stockMode", value);
    setShowAdvancedInventory(value);
  };

  const showControlStockBasic = values.stockMode || showAdvancedInventory;

  const stockMasterSimpleMap = useMemo(() => {
    const result = {};
    stockMasters.forEach((stockMaster) => {
      if (!result[stockMaster?.ownerId?.toString()]) {
        result[stockMaster?.ownerId?.toString()] = parseInt(
          stockMaster?.quantity?.toString()
        );
      } else {
        result[stockMaster.ownerId.toString()] =
          result[stockMaster.ownerId.toString()] +
          parseInt(stockMaster.quantity.toString());
      }
    });
    return result;
  }, [stockMasters]);

  const optionsVariants = itemVariants?.map((s) => ({
    name: s.name,
    value: s._id,
  }));

  optionsVariants.unshift({
    name: t("Items.inventory.noUse"),
    value: null,
  });

  return (
    <>
      <s.Title>{t("Items.inventory.inventoryControl")}</s.Title>
      <s.OptionsBoxContainer>
        <s.OptionRow style={{ paddingRight: "8px" }}>
          <s.OptionTextContainer>
            {t("Items.inventory.useStockControl")}
          </s.OptionTextContainer>
          <Selector
            right="view"
            borderColor="white"
            border="transparent"
            options={optionsControlStock?.map((s) => ({
              name: s.name,
              value: s.value,
            }))}
            style={{ width: 130, marginTop: "9px" }}
            value={showControlStockBasic}
            onChange={(value) => handleStockMode(value)}
          />
        </s.OptionRow>
        {/* change optionsControlStock for data.variants */}
        <s.OptionRow style={{ paddingRight: "8px" }}>
          <s.OptionTextContainer>
            {t("Items.fields.variantId.label")}
          </s.OptionTextContainer>
          <Selector
            right="view"
            borderColor="white"
            border="transparent"
            placeholder={
              itemVariants.length === 0
                ? t("Items.fields.variantId.noVariants")
                : t("Items.fields.variantId.itemsVariants")
            }
            style={{ width: 150, marginTop: "9px" }}
            options={optionsVariants}
            value={values.variantId}
            onChange={(value) => setFieldValue("variantId", value)}
          />
        </s.OptionRow>
        <s.OptionRow>
          <s.OptionTextContainer>
            {t("Items.fields.gtin.label")}
          </s.OptionTextContainer>
          <s.EditableText
            disabled={!values.stockMode}
            placeholder={t("Items.fields.gtin.placeholder")}
            name="gtin"
            onChange={handleChange}
            value={values.gtin}
          />
        </s.OptionRow>

        <s.OptionRow>
          <s.OptionTextContainer>
            {t("Items.fields.barcode.label")} 1
          </s.OptionTextContainer>
          <s.EditableText
            // disabled={!values.stockMode}
            placeholder={t("Items.fields.barcode.placeholder")}
            name="barcode"
            onChange={handleChange}
            value={values.barcode}
          />
        </s.OptionRow>
        <s.OptionRow>
          <s.OptionTextContainer>
            {t("Items.fields.barcode.label")} 2
          </s.OptionTextContainer>
          <s.EditableText
            // disabled={!values.stockMode}
            placeholder={t("Items.fields.barcode.placeholder")}
            name="barcode2"
            onChange={handleChange}
            value={values.barcode2}
          />
        </s.OptionRow>
        {showControlStockBasic === "basic" && (
          <s.OptionRow>
            <s.OptionTextContainer>
              {t("Items.fields.minStock.label")}
            </s.OptionTextContainer>
            <s.EditableText
              placeholder={t("Items.fields.minStock.placeholder")}
              disabled={!values.stockMode}
              name="minStock"
              onChange={(value) =>
                setFieldValue(
                  "minStock",
                  value.target.value === "" ? "0" : value.target.value
                )
              }
              value={parseInt(values.minStock)}
              type="number"
            />
          </s.OptionRow>
        )}
      </s.OptionsBoxContainer>

      {showControlStockBasic === "basic" && (
        <s.OptionsBoxContainer style={{ marginTop: "48px" }}>
          <s.OptionRowStock>
            <s.SlockSectionTitleHeader>
              {t("Items.inventory.stockDetails")}
            </s.SlockSectionTitleHeader>
          </s.OptionRowStock>

          <s.OptionRow color="#F9F9F9">
            <Col span={6}>
              <s.OptionTextContainer>
                {t("Items.fields.barcode.label")}
              </s.OptionTextContainer>
            </Col>
            <Col span={6}>
              <s.OptionTextContainer>{t("Items.item")}</s.OptionTextContainer>
            </Col>
            <Col span={6}>
              <s.OptionTextContainer>
                {t("Items.fields.price.label")}
              </s.OptionTextContainer>
            </Col>
            <Col span={6}>
              <s.OptionTextContainer>{t("Items.stock")}</s.OptionTextContainer>
            </Col>
          </s.OptionRow>
          <s.OptionRow>
            <Col span={6}>
              <s.OptionTextContainer>{values.barcode}</s.OptionTextContainer>
            </Col>
            <Col span={6}>
              <s.OptionTextContainer>{values.name}</s.OptionTextContainer>
            </Col>
            <Col span={6}>
              <s.OptionTextContainer>
                {values.price || 0} €
              </s.OptionTextContainer>
            </Col>
            <Col span={6}>
              <s.OptionTextContainer>
                {stockMasterSimpleMap[values?._id?.toString()]?.toString() ||
                  "-"}
              </s.OptionTextContainer>
            </Col>
          </s.OptionRow>
        </s.OptionsBoxContainer>
      )}
    </>
  );
}

export default InventoryBody;
